<div class="admin-container">

  <app-loading *ngIf="loading"></app-loading>

  <div class="admin-container-header">
    <h4
      class="admin-container-header-item"
      [class.admin-container-header-active]="activeSection === 'bookings' && bookingView === 'dashboard'"
      (click)="goToDashboard()"
    >
      Bookings
    </h4>

    <div class="admin-container-header-actions" style="margin-left: auto; display: flex; align-items: center; gap: 8px;">

      <div class="admin-container-header-settings">
        <button class="settings-btn" (click)="toggleSettings()" [class.active]="settingsOpen">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
          </svg>
        </button>
      </div>

      <h4 (click)="logout()" class="admin-container-header-logout" style="margin: 0;">
        logout
        <app-icon style="margin-left: 0.4rem;" [icon]="Icons.arrowRight" [invert]="true"/>
      </h4>
    </div>
  </div>

  <div class="settings-menu fixed-menu" *ngIf="settingsOpen">
    <div class="settings-menu-label">Таблицы</div>

    <div
      class="settings-menu-item"
      [class.active]="activeSection === 'bookings' && bookingView === 'table'"
      (click)="changeActive('bookings')"
    >
      bookings (таблица)
    </div>

    <div
      *ngFor="let header of secondaryHeaders"
      class="settings-menu-item"
      [class.active]="header === activeSection"
      (click)="changeActive(header)"
    >
      {{ header }}
    </div>
  </div>

  <div class="admin-container-content">

    <app-booking-dashboard
      *ngIf="activeSection === 'bookings' && bookingView === 'dashboard'"
    ></app-booking-dashboard>

    <ng-container *ngIf="activeSection !== 'bookings' || bookingView === 'table'">

      <div class="admin-container-content-list-item">

        <div *ngIf="activeSection !== 'airport-services' && activeSection !== 'main-screen-images'" class="admin-container-content-list-item-search">
          <input
            [placeholder]="'Search...'"
            [(ngModel)]="search"
            (keyup.enter)="searching()"
          >
          <app-icon
            *ngIf="search.length > 2"
            [icon]="Icons.crossClose"
            [invert]="true"
            (click)="clearSearch()"
            class="admin-container-content-list-item-search-icon"
          />
        </div>

        <div *ngIf="activeSection === 'airport-services'" class="admin-container-content-list-item-search">
          <input
            #airportIdInput
            [placeholder]="'Enter Airport ID...'"
            [(ngModel)]="airportIdSearch"
            (keyup.enter)="searchAirportServices()"
            type="number"
          >
          <app-icon
            *ngIf="airportIdSearch"
            [icon]="Icons.crossClose"
            [invert]="true"
            (click)="clearAirportServicesSearch()"
            class="admin-container-content-list-item-search-icon"
          />
        </div>

        <div *ngIf="activeSection === 'main-screen-images'"></div>

        <div class="admin-container-content-list-item-buttons">
          <div
            *ngIf="activeSection !== 'main-screen-images'"
            (click)="activeSection === 'airport-services' ? searchAirportServices() : searching()"
            class="admin-container-content-list-item-buttons-button"
          >
            <app-icon [icon]="Icons.magnifier" [invert]="false"/>
          </div>

          <div
            *ngIf="activeSection !== 'main-screen-images'"
            (click)="activeSection === 'airport-services' ? clearAirportServicesSearch() : clearSearch()"
            class="admin-container-content-list-item-buttons-button"
          >
            Clear Filter
          </div>

          <div (click)="addNewItem()" class="admin-container-content-list-item-buttons-button">
            Add a new item
          </div>
        </div>
      </div>

      <app-sortable-table
        *ngIf="
          (activeSection === 'airport-services' && airportServicesData.length > 0) ||
          (activeSection !== 'airport-services' && (pagination.content || []).length > 0)
        "
        [headers]="tableHeaders[activeSection]"
        [data]="activeSection === 'airport-services' ? airportServicesData : (pagination.content || [])"
        [currentSort]="currentSort"
        [currentSortHeader]="currentSortHeader"
        [getClearSorting]="getClearSorting"
        [activeSection]="activeSection"
        [tableType]="activeSection"
        (openItemEmit)="onOpenItem($event)"
        (sortEmit)="onSort($event)"
        (currentSortHeaderEmit)="onCurrentSortHeader($event)"
        (currentSortEmit)="onCurrentSort($event)"
      />

      <div
        *ngIf="activeSection !== 'airport-services' && activeSection !== 'main-screen-images' && !loading && (pagination.content || []).length === 0"
        class="admin-container-content-list-placeholder"
      >
        <div class="admin-container-content-list-placeholder-content">
          <app-icon [icon]="Icons.magnifier" [invert]="false"/>

          <p *ngIf="search">No results found for "{{ search }}"</p>
          <p *ngIf="!search">No data found</p>

          <span class="admin-container-content-list-placeholder-hint">
          Try changing the search query or clearing the filter
        </span>
        </div>
      </div>

      <div
        *ngIf="activeSection === 'main-screen-images' && !loading && (pagination.content || []).length === 0"
        class="admin-container-content-list-placeholder"
      >
        <div class="admin-container-content-list-placeholder-content">
          <app-icon [icon]="Icons.magnifier" [invert]="false"/>
          <p>No images found</p>
          <span class="admin-container-content-list-placeholder-hint">
          Click "Add a new item" to upload your first image URL
        </span>
        </div>
      </div>

      <div
        *ngIf="activeSection === 'airport-services' && !airportServicesLoaded && !loading"
        class="admin-container-content-list-placeholder"
      >
        <div class="admin-container-content-list-placeholder-content">
          <app-icon [icon]="Icons.magnifier" [invert]="false"/>
          <p>Enter an Airport ID above and click Search</p>
          <span class="admin-container-content-list-placeholder-hint">Example: 1, 2, 3...</span>
        </div>
      </div>

      <div
        *ngIf="activeSection === 'airport-services' && airportServicesLoaded && airportServicesData.length === 0 && !loading"
        class="admin-container-content-list-placeholder"
      >
        <div class="admin-container-content-list-placeholder-content">
          <app-icon [icon]="Icons.crossClose" [invert]="true"/>
          <p>No services found for Airport ID: {{ airportIdSearch }}</p>
        </div>
      </div>

      <div
        *ngIf="activeSection !== 'airport-services' && activeSection !== 'main-screen-images'"
        class="admin-container-content-list-pagination-container"
      >
        <app-pagination
          [pagination]="pagination"
          (emitPagination)="onPaginationChange($event)"
        />
      </div>
    </ng-container>
  </div>
</div>
